/**
 * Viewer error codes.
 */
export var ViewerErrorCode;
(function (ViewerErrorCode) {
    /**
     * Resource failed to load.
     */
    ViewerErrorCode[ViewerErrorCode["FailedLoad"] = 0] = "FailedLoad";
    /**
     * IFC model missing root element.
     */
    ViewerErrorCode[ViewerErrorCode["MissingIFCRoot"] = 1] = "MissingIFCRoot";
    /**
     * Failed to load a panorama 360 sphere.
     */
    ViewerErrorCode[ViewerErrorCode["FailedLoadPanorama"] = 2] = "FailedLoadPanorama";
})(ViewerErrorCode || (ViewerErrorCode = {}));
/**
 * Viewer error interface.
 */
export class ViewerError extends Error {
    constructor(code, message) {
        super(message);
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = code;
    }
}
